import { useState } from 'react'
import { Etichetta, Linguette, Scelta } from '../../componenti/base.tsx'
import { Guscio, usaElenco } from '../../componenti/elenco.tsx'
import { useSessione } from '../../servizi/sessione.tsx'
import { Integrita } from './Integrita.tsx'

/** Classi di evento del registro. I valori sono quelli accettati dall'API. */
const classiEvento = [
  { valore: 'sicurezza', etichetta: 'Sicurezza' },
  { valore: 'lettura', etichetta: 'Lettura' },
  { valore: 'operativo', etichetta: 'Operativo' },
  { valore: 'amministrazione', etichetta: 'Amministrazione' },
  { valore: 'sistema', etichetta: 'Sistema' },
]

export function Audit() {
  // Due cose diverse per due persone diverse: l'elenco degli eventi lo legge chi indaga su un
  // fatto, l'integrita' la guarda chi risponde del registro. Le linguette le tengono separate
  // invece di allungare una pagina sola.
  // L'integrita' la verifica chi ha `audit.verifica` (amministrazione, DPO, fornitore): agli altri,
  // per esempio Direzione e Project Manager, la linguetta non compare (prima dava errore).
  const { puo } = useSessione()
  const verifica = puo('audit.verifica')
  const [linguetta, setLinguetta] = useState<'eventi' | 'integrita'>('eventi')
  const voci = verifica ? VOCI : VOCI.filter((v) => v.valore === 'eventi')
  type Riga = {
    id: string; avvenuto_il: string; azione: string; descrizione: string
    classe: string; esito: string; nome: string | null; cognome: string | null
    oggetto_tipo: string | null; ip_troncato: string | null; ha_motivazione: boolean
    /** Evento scritto in palestra (490), sui dati inventati della sede di formazione. */
    palestra: boolean
  }
  const [classe, setClasse] = useState('')
  const [palestra, setPalestra] = useState('')
  // Il cambio di filtro cambia il percorso: usaElenco riporta la finestra a zero.
  const parametri = new URLSearchParams()
  if (classe) parametri.set('classe', classe)
  if (palestra) parametri.set('palestra', palestra)
  const { dati, errore, finestra } = usaElenco<Riga>(
    `/audit/eventi${parametri.size ? `?${parametri}` : ''}`,
  )
  if (linguetta === 'integrita' && verifica) {
    return (
      <>
        <Linguette attiva={linguetta} cambia={setLinguetta} voci={voci} etichetta="Sezioni del registro" />
        <Integrita />
      </>
    )
  }

  return (
    <>
    {voci.length > 1 && (
      <Linguette attiva={linguetta} cambia={setLinguetta} voci={voci} etichetta="Sezioni del registro" />
    )}
    <Guscio titolo="Registro eventi" errore={errore} dati={dati} finestra={finestra}
            vuoto="Nessun evento."
            sottotitolo="Registro non modificabile."
            intestazioni={['Quando', 'Chi', 'Cosa', 'Oggetto', 'Esito', 'Rete']}
            azioni={
              <div className="filtro-intestazione">
                <Scelta etichetta="Classe" valore={classe} cambia={setClasse}
                        opzioni={classiEvento} vuota="Tutte le classi" />
                <Scelta etichetta="Palestra" valore={palestra} cambia={setPalestra} vuota="Tutti gli eventi"
                        opzioni={[{ valore: 'escludi', etichetta: 'Senza la palestra' },
                          { valore: 'solo', etichetta: 'Solo la palestra' }]} />
              </div>
            }>
      {dati?.map((e) => (
        <tr key={e.id}>
          <td data-etichetta="Quando" className="piccolo">{new Date(e.avvenuto_il).toLocaleString('it-IT')}</td>
          <td data-etichetta="Chi">{e.cognome ? `${e.cognome} ${e.nome}` : <span className="tenue">sistema</span>}</td>
          <td data-etichetta="Cosa">
            {e.descrizione}
            {e.ha_motivazione && <> <Etichetta tono="riservato">motivato</Etichetta></>}
            {e.palestra && <> <Etichetta tono="attenzione">palestra</Etichetta></>}
          </td>
          <td data-etichetta="Oggetto" className="piccolo tenue">{e.oggetto_tipo ?? '—'}</td>
          <td data-etichetta="Esito">
            <Etichetta tono={e.esito === 'ok' ? 'positivo' : 'critico'}>{e.esito}</Etichetta>
          </td>
          <td data-etichetta="Rete" className="mono piccolo">{e.ip_troncato ?? '—'}</td>
        </tr>
      ))}
    </Guscio>
    </>
  )
}

const VOCI = [
  { valore: 'eventi' as const, etichetta: 'Eventi' },
  { valore: 'integrita' as const, etichetta: 'Integrità' },
]
